import { graphql, useStaticQuery } from "gatsby";

interface PreloadCeidFormContent {
    tituloGeneral: string;
    descripcion: {
        raw: string;
    };
    descripcionFija: {
        raw: string;
    };
    tituloSeccion: string;
    redireccionBoton: string;
    tituloBoton: string;
    referenciaFormulario: {
        id: string;
        tipoCampo: string;
        listaSelect: string[];
        mensajeError: string;
        inputPrincipal: string;
        nombreId: string;
        tituloBotonTerminos: string;
        textoTerminos: {
            raw: string;
        };
        obligatorio: boolean;
        seccion: string;
        tabOrder: number;
        ayuda: string;
        placeholder: string;
    }[];
}

export const useFormPreloadCeidDataContent = () => {
    const { formData } = useStaticQuery(graphql`
        query FormCeidPreLoadData {
            formData: allContentfulTitulosGeneralesCategorias(
                filter: { contentful_id: { eq: "5kT4pwJVv7MKxbYZFbXofN" } }
            ) {
                nodes {
                    tituloGeneral
                    descripcion {
                        raw
                    }
                    descripcionFija {
                        raw
                    }
                    tituloSeccion
                    tituloBoton
                    redireccionBoton
                    referenciaFormulario {
                        id
                        tipoCampo
                        listaSelect
                        mensajeError
                        inputPrincipal
                        nombreId
                        tituloBotonTerminos
                        textoTerminos {
                            raw
                        }
                        obligatorio
                        seccion
                        tabOrder
                        ayuda
                        placeholder
                    }
                }
            }
        }
    `);
    const content = formData?.nodes[0] || {};
    return content as PreloadCeidFormContent;
};
